require('../../../assets/lib/jquery/jquery-ui-1.13.2.min.js');
require('../../../assets/lib/js/angularmodule/angdirective.js');
require('../../../assets/scripts/common/jv.Filters.js');
require('../../../assets/scripts/common/jv.Loading.js');
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/lib/js/angularmodule/angservice.js');
require('../../../assets/lib/js/angularmodule/JV.Core.Directives.webpack.js');
require('../../../assets/scripts/source/messages/JV.Messages.js');